// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"Fieldset_fieldset__2RRt2"};